// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1xoOU","content":"LoadingAlert_content__cRqm7"};